import SeatAvtarMenImg from "../../assets/images/cms/seat-avtar-men.png";
import SeatAvtarGirlImg from "../../assets/images/cms/seat-avtar-girl.png";

/** Matches CreateGame.tsx — shared by GameResultTeamLobby */
export const plusIconSize = `
absolute
z-[30]
2xl:w-[2vw] lg:w-8 md:w-5 sm:w-4 w-2.5 
2xl:p-[0.10vw] xl:p-0.5 lg:p-1 p-[1px]
2xl:rounded-[0.1041vw] rounded-sm 2xl:border-[0.1041vw] md:border-2 border-1 border landscape:max-lg:border border-black cursor-pointer aspect-square justify-center items-center flex bg-[#97A4F2]
`;

const benchSlotDivMax =
  "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px]";

const benchAchievementWrapper =
  "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2";

const benchAchievementTextBase =
  "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706]";

const benchAchievementTextMidFirstSeat = "2xl:text-[0.42vw]/tight md:text-[8px]/tight text-[5px]/tight";
const benchAchievementTextMidRest = "2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight";

const benchAchievementTextTailFirstSeat =
  "font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[60px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis";
const benchAchievementTextTailDefault =
  "font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis";
const benchAchievementTextTailLandscapeCap =
  "font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] landscape:max-lg:max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis";

const benchAchievementTextFirstSeat = `${benchAchievementTextBase} ${benchAchievementTextMidFirstSeat} ${benchAchievementTextTailFirstSeat}`;
const benchAchievementTextDefault = `${benchAchievementTextBase} ${benchAchievementTextMidRest} ${benchAchievementTextTailDefault}`;

const benchSittingCharacterNameClass =
  "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.20vw] 2xl:px-[0vw] sm:px-0.5 2xl:max-w-[3.4vw] lg:max-w-[58px] md:max-w-[50px] max-w-[34px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap";

const benchInviteTimerClass =
  "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight";

const benchImageLeftHalf = "w-full ltr:-scale-x-100 object-contain";
const benchImageRightHalf = "w-full rtl:-scale-x-100 object-contain";

const centerBenchSlotTop = `${benchSlotDivMax} 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5`;

const slotDiv = (position: string) => `${benchSlotDivMax} ${position}`;
const centerSlotDiv = (horizontal: string) => `${centerBenchSlotTop} ${horizontal}`;

export const leftBenchCharacterClassnames = {
  0: {
    div: slotDiv("2xl:top-[8%] top-[12%] xl:start-[8.5%] start-[8.5%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextFirstSeat,
    image: benchImageLeftHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  1: {
    div: slotDiv("2xl:top-[4%] top-[7%] xl:start-[14%] start-[14%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageLeftHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  2: {
    div: slotDiv("2xl:top-[0%] top-[2%] xl:start-[19%] sm:start-[19%] start-[19.5%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageLeftHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  3: {
    div: slotDiv("2xl:top-[-1vw] md:top-[-10px] sm:top-[-5px] top-0 xl:start-[24%] sm:start-[24%] start-[25%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageLeftHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  4: {
    div: slotDiv(
      "2xl:top-[-1.5vw] md:top-[-20px] sm:top-[-15px] top-[-3px] xl:start-[29.5%] sm:start-[29.5%] start-[30%] z-10"
    ),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageLeftHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  5: {
    div: slotDiv(
      "2xl:top-[-2vw] md:top-[-30px] sm:top-[-20px] top-[-5px] xl:start-[34.5%] sm:start-[34.5%] start-[35%] z-10"
    ),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageLeftHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  6: {
    div: slotDiv("2xl:top-[-2.5vw] md:top-[-40px] sm:top-[-26px] top-[-10px] xl:start-[40%] start-[40%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageLeftHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
} as const;

const benchAchievementTextRightFive = `${benchAchievementTextBase} ${benchAchievementTextMidRest} ${benchAchievementTextTailLandscapeCap}`;

export const rightBenchCharacterClassnames = {
  0: {
    div: slotDiv("2xl:top-[-2.5vw] md:top-[-40px] sm:top-[-26px] top-[-10px] xl:end-[40%] end-[40%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageRightHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  1: {
    div: slotDiv(
      "2xl:top-[-2vw] md:top-[-30px] sm:top-[-20px] top-[-5px] xl:end-[34.5%] sm:end-[34.5%] end-[35%] z-10"
    ),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageRightHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  2: {
    div: slotDiv(
      "2xl:top-[-1.5vw] md:top-[-20px] sm:top-[-15px] top-[-3px] xl:end-[29.5%] sm:end-[29.5%] end-[30%] z-10"
    ),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageRightHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  3: {
    div: slotDiv("2xl:top-[-1vw] md:top-[-10px] sm:top-[-5px] top-0 xl:end-[24%] sm:end-[24%] end-[25%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageRightHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  4: {
    div: slotDiv("2xl:top-[0%] top-[2%] xl:end-[19%] sm:end-[19%] end-[19.5%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageRightHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  5: {
    div: slotDiv("2xl:top-[4%] top-[7%] xl:end-[14%] end-[14%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextRightFive,
    image: benchImageRightHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
  6: {
    div: slotDiv("2xl:top-[8%] top-[12%] xl:end-[8.5%] end-[8.5%] z-10"),
    achivementWraper: benchAchievementWrapper,
    achivementText: benchAchievementTextDefault,
    image: benchImageRightHalf,
    name: benchSittingCharacterNameClass,
    timer: benchInviteTimerClass,
  },
} as const;

type BenchCharacterSlotClasses = {
  div: string;
  achivementWraper: string;
  achivementText: string;
  image: string;
  name: string;
  timer: string;
};

export const centerBenchCharacterClassnames: Record<number, BenchCharacterSlotClasses> = {
  0: {
    ...leftBenchCharacterClassnames[0],
    div: centerSlotDiv("xl:start-[8.5%] start-[8.5%] z-10"),
  },
  1: {
    ...leftBenchCharacterClassnames[1],
    div: centerSlotDiv("xl:start-[20%] start-[20%] z-10"),
  },
  2: {
    ...leftBenchCharacterClassnames[2],
    div: centerSlotDiv("xl:start-[32%] start-[32%] z-10"),
  },
  3: {
    ...leftBenchCharacterClassnames[3],
    div: centerSlotDiv("xl:start-[43.5%] start-[43.5%] z-10"),
  },
  4: {
    ...leftBenchCharacterClassnames[4],
    div: centerSlotDiv("xl:start-[56%] start-[56%] z-10"),
  },
  5: {
    ...leftBenchCharacterClassnames[5],
    div: centerSlotDiv("xl:start-[68%] start-[68%] z-10"),
  },
  6: {
    ...leftBenchCharacterClassnames[6],
    div: centerSlotDiv("xl:start-[80%] start-[80%] z-10"),
  },
};

const benchStandingWrapperBase =
  "absolute z-20 flex flex-col items-center 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] md:w-[90px] sm:w-[70px] w-[40px] 2xl:-top-[2.083vw] xl:top-0 lg:top-3 md:top-0 -top-2";

export const leftBenchStandingPlayerWrapper = `${benchStandingWrapperBase} xl:-start-[1.615vw] xl:-start-[20px] sm:-start-3 -start-1`;

export const rightBenchStandingPlayerWrapper = `${benchStandingWrapperBase} xl:-end-[1.615vw] xl:-end-[20px] sm:-end-3 -end-1`;

export const centerBenchStandingPlayerWrapper =
  "absolute z-20 flex flex-col items-center 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] md:w-[90px] sm:w-[70px] w-[40px] 2xl:-top-[4.5vw] xl:-top-10 lg:-top-8 md:-top-6 sm:-top-10 -top-8 2xl:-start-[6vw] md:-start-[80px] sm:-start-15 -start-10";

const benchStandingImageSize = "h-auto 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] sm:w-[90px] w-[50px] object-contain";

export const standingPlayerImageClass = `${benchStandingImageSize} ltr:-scale-x-100 rtl:scale-x-100`;

export const standingPlayerImageClassRightBench = `${benchStandingImageSize} ltr:scale-x-100 rtl:-scale-x-100`;

export const standingPlayerImageClassCenterBench = `${benchStandingImageSize} ltr:-scale-x-100 rtl:scale-x-100`;

export const standingPlayerNameClass =
  "mt-1 px-1 text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 max-w-full whitespace-normal break-words leading-tight";

export const benchSpriteCharacters = {
  0: { female: SeatAvtarGirlImg, male: SeatAvtarMenImg },
  1: { female: SeatAvtarGirlImg, male: SeatAvtarMenImg },
  2: { female: SeatAvtarGirlImg, male: SeatAvtarMenImg },
  3: { female: SeatAvtarGirlImg, male: SeatAvtarMenImg },
  4: { female: SeatAvtarGirlImg, male: SeatAvtarMenImg },
  5: { female: SeatAvtarGirlImg, male: SeatAvtarMenImg },
  6: { female: SeatAvtarGirlImg, male: SeatAvtarMenImg },
} as const;

export type BenchLayout = "fullRowLeft" | "fullRowRight" | "centerBench";
